"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _reactTransitionGroup = require("react-transition-group");
var _StepTwoModule = _interopRequireDefault(require("../../styles/components/Flushing/StepTwo.module.css"));
var _selectors = require("../../redux/selectors");
var _actions = require("../../redux/actions");
var _Temperature = _interopRequireDefault(require("./Temperature"));
var _useHandleFlushDuration = _interopRequireDefault(require("../../hooks/useHandleFlushDuration"));
var _ValveRotationCircle = _interopRequireDefault(require("./ValveRotationCircle"));
var _constants = require("../../utils/constants");
var _FlushingCircle = _interopRequireDefault(require("./FlushingCircle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StepTwo = _ref => {
  let {
    thingPDIDDevice
  } = _ref;
  const timeout = (0, _react.useRef)(null);
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    process
  } = (0, _reactRedux.useSelector)(store => (0, _selectors.selectActiveStepById)({
    store,
    thingPDIDDevice
  }));
  const {
    handleFlushDuration
  } = (0, _useHandleFlushDuration.default)({
    thingPDIDDevice
  });
  const handleStop = (0, _react.useCallback)(() => {
    if (timeout.current) clearTimeout(timeout.current);
    dispatch((0, _actions.setFlushingStep)({
      thingPDIDDevice,
      step: 1
    }));
    /** send stop flush command only on open valve step */
    if (process === _constants.flushProcess.open) {
      timeout.current = setTimeout(() => handleFlushDuration(0), 500);
    }
  }, [dispatch, thingPDIDDevice, handleFlushDuration]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.SwitchTransition, {
    mode: "out-in",
    className: "w-100 h-100"
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    key: process,
    timeout: 250,
    addEndListener: (node, done) => node.addEventListener('transitionend', done, false),
    classNames: "fade-card fade"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, process === _constants.flushProcess.flush ? /*#__PURE__*/_react.default.createElement(_FlushingCircle.default, {
    thingPDIDDevice: thingPDIDDevice
  }) : /*#__PURE__*/_react.default.createElement(_ValveRotationCircle.default, {
    thingPDIDDevice: thingPDIDDevice
  })))), /*#__PURE__*/_react.default.createElement(_Temperature.default, {
    thingPDIDDevice: thingPDIDDevice
  }), /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "btn-b btn-primary br-btn px-20 ".concat(_StepTwoModule.default.btn),
    onClick: handleStop
  }, process === _constants.flushProcess.close ? 'start new flush' : 'cancel')), [handleStop, thingPDIDDevice, process]);
};
var _default = exports.default = StepTwo;